import { createContext, useContext, type ReactNode } from 'react';

import type { HandshakeState } from '@/handshake/useHandshake.js';

const HandshakeContext = createContext<HandshakeState | null>(null);

export function HandshakeContextProvider({
  value,
  children,
}: {
  value: HandshakeState;
  children: ReactNode;
}) {
  return <HandshakeContext.Provider value={value}>{children}</HandshakeContext.Provider>;
}

export function useHandshakeContext(): HandshakeState {
  const value = useContext(HandshakeContext);
  if (!value) {
    throw new Error('useHandshakeContext must be used inside <HandshakeContextProvider>');
  }
  return value;
}
